import { ref, watch } from 'vue'
import { translateLocationName } from '../utils/locationNameTranslator'

export function useLocationTranslation(
  getLocation: () => string,
  getLanguage: () => string,
  getCountryCode: () => string | undefined
) {
  const translatedCityName = ref<string>('')
  const translatedCountryName = ref<string>('')

  const translate = async (language: string, location: string, countryCode: string | undefined) => {
    const countryName = localStorage.getItem('cityCountryName') || countryCode || ''

    try {
      if (location) {
        translatedCityName.value = await translateLocationName(location, language)
      }
      if (countryName) {
        translatedCountryName.value = await translateLocationName(countryName, language)
      }
    } catch (error) {
      console.warn('⚠️ Failed to translate location names:', error)
      translatedCityName.value = location
      translatedCountryName.value = countryName
    }
  }

  watch(
    [getLanguage, getLocation, getCountryCode],
    ([language, location, countryCode]) => {
      translate(language, location, countryCode)
    },
    { immediate: true }
  )

  return { translatedCityName, translatedCountryName }
}
